import request from '@/utils/request'
// 参观确认时间
export function getVisitTime(params) {
  return request({
    url: 'client-message-operate!visitAscertainedTime.do?param='+params,
    method: 'get'
  })
}
// 选择展厅
export function getExhibtionRoom(params) {
  return request({
    url: 'client-message-operate!changeExhibitionRoom.do?param='+params,
    method: 'get',
    params
  })
}
// 参观预约
export function submitVisitReserve(data) {
  return request({
    url: 'client-message-operate!visitReserve.do?param='+data,
    method: 'get',
    //data:data
  })
}
// 参观预约查询
export function selectVisit(params) {
  return request({
    url: 'client-message-operate!visitReserveSelect.do?param='+params,
    method: 'get',
    params
  })
}
// 参观预约查询
// export function selectVisit(params) {
//   return request({
//     url: '/visit_reserve_select',
//     method: 'get',
//     params
//   })
// }

// 参观预约取消
export function delVisit(params) {
    return request({
      url: 'client-message-operate!delVisitReserve.do?param='+params,
      method: 'get',
      params
    })
  }
// 查档预约取消
export function delConsult(params) {
    return request({
      url: 'client-message-operate!delConsult.do?param='+params,
      method: 'get',
      params
    })
  }